module.exports = "../images/hiking-fishing-lodge-ontario@2x.jpg?v=b0b0d4c";